import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: []
}

const bloombergSlice = createSlice({
  name: 'bloomberg',
  initialState,
  reducers: {
    setBloombergSnapshot: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { setBloombergSnapshot } = bloombergSlice.actions

export default bloombergSlice.reducer
